import styled from 'styled-components';

export const GroupHeaderFollowerInfoSection = styled.div`
    &&& {
        display: flex;
        align-items: center;
        gap: 6px;
        padding-left: 1px;

        @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
            gap: 2px;
        }
    }
`;
